export default "__VITE_ASSET__BeCediFL__"